export function useSyteSimilarItems(
  params: MaybeRefOrGetter<number>,
  options?: AsyncRpcOptions<'getSyteSimilarItems'>,
) {
  const key = `getSyteSimilarItems-${toValue(params)}`

  return useRpc('getSyteSimilarItems', key, params, options)
}
